import { render, staticRenderFns } from "./problemRelationDialog.vue?vue&type=template&id=20a67948&scoped=true&"
import script from "./problemRelationDialog.vue?vue&type=script&lang=js&"
export * from "./problemRelationDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a67948",
  null
  
)

export default component.exports